import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FullscreenImage from "../../shared/components/images/FullscreenImage";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@material-ui/core";
import { Skeleton } from "@mui/material";
import useStyles from "./styles";
import ReviewModal from "./ReviewModal";
import Review from "../../model/review";
import { PrimaryColor } from "../../shared/styles/colors";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "85%",
  },
};

//TODO: implement new design

interface Props {
  item: Review;
  resetList?: () => void;
}

const ReviewDetailModal = ({ item, resetList }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [fullScreen, setFullScreen] = useState(false);

  const toggleFullScreen = () => {
    setFullScreen((fullScreen) => !fullScreen);
  };

  return (
    <div>
      <Button onClick={handleOpen}>
        <MoreVertIcon sx={{ color: PrimaryColor}}/>
      </Button>
      {fullScreen ? (
        <FullscreenImage
          imageUrl={item.imageUrl}
          toggleFullScreen={toggleFullScreen}
        />
      ) : (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ overflowY: "auto" }}
        >
          <Box sx={style}>
            <div className={classes.headerDiv}>
              <Typography className={classes.title}>Details</Typography>
              <div className={classes.headerSubDiv}>
                <ReviewModal item={item} resetList={resetList} />
                <Button onClick={handleClose} sx={{ color: "black" }}>
                  <CloseIcon />
                </Button>
              </div>
            </div>
            <hr />
            <div className={classes.form}>
              <div className={classes.container}>
                <div className="d-flex row">
                  <div className="mt-2">
                    <Typography className={classes.label}>Id</Typography>
                    <Typography className={classes.inputDetail}>
                      {item.id}
                    </Typography>
                  </div>
                  <div className="mt-2">
                    <Typography className={classes.label}>Service</Typography>
                    <Typography className={classes.inputDetail}>
                      {item?.Service?.name}
                    </Typography>
                  </div>
                  <div className="mt-2">
                    <Typography className={classes.label}>Location</Typography>
                    <Typography className={classes.inputDetail}>
                      {item.location}
                    </Typography>
                  </div>
                  <div className="mt-2">
                    <Typography className={classes.label}>
                      Description
                    </Typography>
                    <textarea
                      className={classes.textareaDetail}
                      value={item.description}
                      disabled
                    />
                  </div>
                </div>
                {item.imageUrl ? (
                  <img
                    className={classes.image}
                    src={item.imageUrl}
                    alt="review img"
                    onClick={() => toggleFullScreen()}
                  />
                ) : (
                  <Skeleton variant="rectangular" width={1000} height={500} />
                )}
              </div>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default ReviewDetailModal;
